var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:['same-building-head', { 'pc-selected-card': _vm.pcSelectedCard }],attrs:{"href":"#","aria-label":_vm.buildingName},on:{"click":_vm.showSameBuildingList}},[_c('span',{staticClass:"material-icons"},[_vm._v("business")]),_c('span',{staticClass:"head-title"},[_vm._v(_vm._s(_vm.buildingName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }